// extracted by mini-css-extract-plugin
module.exports = {"threeboxes":"ThreeBoxes_threeboxes__mLtCQ","wrap":"ThreeBoxes_wrap__dUVFT"};